import { API } from "../../types";

export interface WeatherLocation {
  id: string;
  name: string;
  admin1?: string;
  country: string;
  countryCode?: string;
  latitude: number;
  longitude: number;
  timezone?: string;
}

export interface OpenMeteoCurrentWeather {
  temperature_2m: number;
  apparent_temperature: number;
  weather_code: number;
  is_day: number;
  wind_speed_10m: number;
}

export interface OpenMeteoWeatherResponse {
  current?: OpenMeteoCurrentWeather;
}

export type WeatherData = {
  location?: WeatherLocation;
  units?: "metric";
  style?: "cinematic";
  city?: string;
  autoLocateAttempted?: boolean;
};

export type Props = API<WeatherData>;

export const defaultData: WeatherData = {
  units: "metric",
  style: "cinematic",
  autoLocateAttempted: false,
};
